export default {
    apiServerUrl: 'http://ec2-18-188-186-133.us-east-2.compute.amazonaws.com:8000/',
    generalApiUrl: 'api/v1/',
    deviceApiUrl: 'device/api/v1/',
    loginUrl: 'accounts/api/v1/login/',
  };
  const cityCodes = [5,7,8]; // Replace with the desired city codes

  const siteConfig = {
    siteName: 'JWARCMS',
    siteIcon: 'ion-flash',
    footerText: 'JWAR ©2024'
  };
  
  const themeConfig = {
    topbar: 'themedefault',
    sidebar: 'themedefault',
    layout: 'themedefault',
    theme: 'themedefault'
  };
  const language = 'english';

  export {
    siteConfig,
    themeConfig,
    language,
    cityCodes
  };



// WEBPACK FOOTER //
// ./src/config.js